module.exports = "<gw-bop-additional-coverages update-coverages=\"updateCoverages\"/>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/quoteandbind/ama/cpp/views/cpp-additional-coverages.html
// module id = 468
// module chunks = 0